export default __webpack_public_path__ + "static/4-5eaa01372b4a16852fc35ef4e5d624b9.jpg";